export const MuiStepLabel = {
  styleOverrides: {
    root: {
      '.MuiStepLabel-label.Mui-active': {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '157%',
      },

      '.MuiStepLabel-label.Mui-completed': {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '157%',
      },

      '.MuiStepLabel-label.Mui-disabled': {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '157%',
      },
    },
  },
}
